(function() { window.GUID_801ef590_00a6_4801_92ca_9cd0b42fc64c = { getGuid: function() { return "801ef590-00a6-4801-92ca-9cd0b42fc64c"; } }; })();
var CS;
(function (CS) {
    class Radio {
        constructor(inputBox) {
            this.SetStyle = function () {
            };
            this.SetEvents = function () {
                var me = this;
                $(this.Radio).off('change');
                $(this.Radio).on('change', function () {
                    me.Radio.trigger("CSChange", me);
                });
            };
            this.Radio = $(inputBox);
            //Protection pour le nouveau helper
            if (this.Radio.hasClass('IHasChanged')) {
                return;
            }
            this.RadioId = this.Radio[0].id;
            this.SetEvents();
        }
    }
    CS.Radio = Radio;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSRadio = function () {
        this.each(function () {
            var radio = new CS.Radio($(this));
            //Donne access au checkbox de n'importe quels scripts.
            if (radio.RadioId != "")
            {
                eval('document.' + radio.RadioId + '=radio;');
            }
        });
    };
})(jQuery);


var CS = CS || {};

CS.Radio = function (inputBox) {

    this.Radio = $(inputBox);
    this.RadioId = this.Radio[0].id;
    this.SetEvents();
};

CS.Radio.prototype = function () {

    var SetStyle = function () {

    },
    SetEvents = function () {
        var me = this;
        
        $(this.Radio).off('change');
        $(this.Radio).on('change', function () {

            me.Radio.trigger("CSChange", me);

        });
    };
    return {
        SetStyle: SetStyle,
        SetEvents: SetEvents
    };

}();
*/ 

//# sourceMappingURL=cs.radio.js.map
